import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, ReactElement } from 'react';

import { GroupsPlaceholder } from '@gem/components';
import { IcAddUserIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import {
  customScrollStyles,
  IconView,
  InfoBlock,
  InfoBlockTypes,
  MenuItem,
  MenuItemStyle,
} from '@gem/ui-kit';

import { IGroupMember } from 'APP/Tasks/group/participants/getParticipants';
import { List } from 'APP/components/List/List';

import { ParticipantListItem } from '../ParticipantListItem/ParticipantListItem';
import { useParticipantListPresenter } from './ParticipantList.presenter';
import styles from './ParticipantList.styles.m.css';
import type { IParticipantListProps } from './ParticipantList.types';

export const ParticipantList: FC<IParticipantListProps> = observer((props) => {
  const { group, searchText, onAddParticipantClick, onParticipantClick } = props;

  const { t } = useTranslation();
  const presenter = useParticipantListPresenter({ group, searchText, onAddParticipantClick });

  return (
    <div className={classNames(styles.container, customScrollStyles.container)}>
      {presenter.canAddParticipants && (
        <MenuItem
          className={styles.button}
          title={t('group_chat_add_people_button')}
          icon={
            <IconView
              Icon={IcAddUserIcon}
              className={styles.listIcon}
            />
          }
          style={MenuItemStyle.BrandPrimary}
          onClick={presenter.showAddPeople}
        />
      )}
      <List
        isLoading={presenter.isLoading}
        hasMore={presenter.hasMore}
        data={presenter.participants}
        onEndReached={presenter.loadMore}
        keyExtractor={(participant: IGroupMember): string => participant.user.id}
        renderItem={(participant: IGroupMember): ReactElement => (
          <ParticipantListItem
            participant={participant}
            group={group}
            onReloadParticipantsList={presenter.onReloadParticipantsList}
            onParticipantRemove={presenter.removeParticipant}
            onUpdateParticipantRole={presenter.updateParticipantRole}
            onParticipantClick={onParticipantClick}
          />
        )}
        ListEmptyComponent={
          <InfoBlock
            descriptions={[t('no_results_found')]}
            type={InfoBlockTypes.Modal}
          />
        }
        SpinnerComponent={
          <GroupsPlaceholder
            className={styles.placeholders}
            count={presenter.participants.length > 0 ? 2 : 10}
          />
        }
      />
    </div>
  );
});
